import { useEffect, useState } from "react";
import { API_URL } from "../../config";
import swal from "sweetalert";
import "./css/IndustryManagerForm.css";

export default function CreateIndustryMarketing() {
    const [form, setForm] = useState({
        fullName: "",
        email: "",
        password: "",
        phone: "",
        designation: "Marketing Officer",
    });
    const [salesPersons, setSalesPersons] = useState([]);
    const [listLoading, setListLoading] = useState(false);
    const [listError, setListError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editLoading, setEditLoading] = useState(false);
    const [deleteLoadingId, setDeleteLoadingId] = useState(null);
    const [editTargetId, setEditTargetId] = useState(null);
    const [editForm, setEditForm] = useState({
      full_name: "",
      email: "",
      phone_number: "",
      department: "Marketing Officer",
      account_status: "active",
      password: "",
    });

    const formatDateTime = (value) => {
      if (!value) return "Invalid date";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "Invalid date";
      return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    };

    const getSalesPersons = async () => {
      
    const authRaw = sessionStorage.getItem("auth_info");
        if (!authRaw) {
            swal("Authentication info missing", "", "warning");
            return;
        }

        const authInfo = JSON.parse(authRaw);
    const token = authInfo.token;
    
      setListLoading(true);
      setListError("");
      try {
         const res = await fetch(`${API_URL}/api/get-all-sales-person`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
  });
          const data = await res.json();
          
          console.log("data: ", data);
          

        // API shape can vary: array or wrapped payload
        const list = Array.isArray(data)
          ? data
          : Array.isArray(data?.message)
            ? data.message
            : Array.isArray(data?.data)
              ? data.data
              : [];

        setSalesPersons(list);
      } catch (error) {
        setListError("Failed to load sales persons");
      } finally {
        setListLoading(false);
      }
    };

    const getSalesPersonId = (row) => {
      return row?.id || row?.sales_person_id || row?.user_id || null;
    };

    const openEditModal = (row) => {
      const id = getSalesPersonId(row);
      if (!id) {
        swal("Sales person id not found", "", "error");
        return;
      }

      setEditTargetId(id);
      setEditForm({
        full_name: row?.full_name || "",
        email: row?.email || "",
        phone_number: row?.phone_number || "",
        department: row?.department || "Marketing Officer",
        account_status: row?.account_status || "active",
        password: row?.password || "",
      });
      setShowEditModal(true);
    };

    const handleEditInputChange = (e) => {
      const { name, value } = e.target;
      setEditForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    };

    const handleUpdateSalesPerson = async (e) => {
      e.preventDefault();

      if (!editTargetId) {
        swal("Invalid sales person id", "", "error");
        return;
      }

      const authRaw = sessionStorage.getItem("auth_info");
      if (!authRaw) {
        swal("Authentication info missing", "", "warning");
        return;
      }

      const authInfo = JSON.parse(authRaw);
      const token = authInfo.token;

      if (!token) {
        swal("Invalid authentication data", "", "error");
        return;
      }

      const payload = {
        full_name: editForm.full_name,
        email: editForm.email,
        phone_number: editForm.phone_number,
        department: editForm.department,
        account_status: editForm.account_status,
        password: editForm.password,
      };

      try {
        setEditLoading(true);
        const res = await fetch(
          `${API_URL}/api/update-sales-person/${editTargetId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              "auth-token": token,
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          }
        );
        const data = await res.json();

        if (!data.error) {
          swal("Sales person updated successfully", "", "success");
          setShowEditModal(false);
          setEditTargetId(null);
          getSalesPersons();
        } else {
          swal(data.message || "Failed to update sales person", "", "error");
        }
      } catch (error) {
        console.error(error);
        swal("Server error", "", "error");
      } finally {
        setEditLoading(false);
      }
    };

    const handleDeleteSalesPerson = async (row) => {
      const salesPersonId = getSalesPersonId(row);
      if (!salesPersonId) {
        swal("Sales person id not found", "", "error");
        return;
      }

      const shouldDelete = await swal({
        title: "Are you sure?",
        text: "This sales person will be deleted permanently.",
        icon: "warning",
        buttons: ["Cancel", "Yes"],
        dangerMode: true,
      });

      if (!shouldDelete) return;

      const authRaw = sessionStorage.getItem("auth_info");
      if (!authRaw) {
        swal("Authentication info missing", "", "warning");
        return;
      }

      const authInfo = JSON.parse(authRaw);
      const token = authInfo.token;
      if (!token) {
        swal("Invalid authentication data", "", "error");
        return;
      }

      try {
        setDeleteLoadingId(salesPersonId);
        const res = await fetch(`${API_URL}/api/delete-sales-person/${salesPersonId}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "auth-token": token,
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();

        if (!data.error) {
          await swal("Deleted", "Sales person deleted successfully", "success");
          if (editTargetId === salesPersonId) {
            setShowEditModal(false);
            setEditTargetId(null);
          }
          getSalesPersons();
        } else {
          swal("Failed", data.message || "Failed to delete sales person", "error");
        }
      } catch (error) {
        console.error(error);
        swal("Error", "Server error", "error");
      } finally {
        setDeleteLoadingId(null);
      }
    };

    useEffect(() => {
      getSalesPersons();
    }, []);

    // Handle input change
    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    // Handle submit
    const handleSubmit = async (e) => {
        e.preventDefault();

        const authRaw = sessionStorage.getItem("auth_info");
        if (!authRaw) {
            swal("Authentication info missing", "", "warning");
            return;
        }

        const authInfo = JSON.parse(authRaw);
        const token = authInfo.token;
        const branchName = authInfo.userInfo?.branch_name;
        const branchEmail = authInfo.userInfo?.user_email
            ;

        if (!token || !branchName) {
            swal("Invalid authentication data", "", "error");
            return;
        }

        const payload = {
          full_name: form.fullName,
          department: form.designation,

          email: form.email,
          password: form.password,
          phone_number: form.phone,
          account_status: "active",
        };

        try {
            const res = await fetch(`${API_URL}/api/create-sales-person`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "auth-token": token,
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (!data.error) {
              swal("Marketing Officer Created Successfully", "", "success");
              getSalesPersons();
            } else {
              swal(data.message || "Failed to create marketing officer", "", "error");
            }
        } catch (err) {
            console.error(err);
            swal("Server error", "", "error");
        }
    };

    return (
      <div >
        <form className="form-card" onSubmit={handleSubmit}>
          {/* BASIC INFO */}
          <div className="form-section">
            <h3>Basic Information</h3>

            <div className="form-row">
              <div className="form-group">
                <label>Full Name</label>
                <input
                  name="fullName"
                  value={form.fullName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Email</label>
                <input
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group password-group">
                <label>Password</label>

                <div className="password-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={form.password}
                    onChange={handleChange}
                    required
                  />

                  <span
                    className="password-eye"
                    onClick={() => setShowPassword(!showPassword)}
                    title={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? "🙈" : "👁️"}
                  </span>
                </div>
              </div>

              <div className="form-group">
                <label>Phone</label>
                <input
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* <div className="form-row">
                    <div className="form-group">
                        <label>Employee Code</label>
                        <input value="AUTO-GENERATED" disabled />
                    </div>
                </div> */}
          </div>

          {/* JOB INFO */}
          <div className="form-section">
            <h3>Job Information</h3>

            <div className="form-row">
              <div className="form-group">
                <label>Designation</label>
                <select
                  name="designation"
                  value={form.designation}
                  onChange={handleChange}
                >
                  <option>Marketing Officer</option>
                  <option>Industry Manager</option>
                </select>
              </div>

              {/* <div className="form-group">
                        <label>Joining Date</label>
                        <input
                            type="date"
                            name="joiningDate"
                            value={form.joiningDate}
                            onChange={handleChange}
                        />
                    </div> */}
            </div>
          </div>

          {/* INDUSTRY */}
          {/* <div className="form-section">
                <h3>Industry Assignment</h3>

                <div className="form-row">
                    <div className="form-group">
                        <label>Industry Type</label>
                        <select
                            name="industryType"
                            value={form.industryType}
                            onChange={handleChange}
                        >
                            <option>Plastic</option>
                            <option>Textile</option>
                            <option>E-Waste</option>
                            <option>Metal</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Division</label>
                        <select
                            name="division"
                            value={form.division}
                            onChange={handleChange}
                        >
                            <option>Dhaka</option>
                            <option>Chattogram</option>
                            <option>Khulna</option>
                        </select>
                    </div>
                </div>
            </div> */}

          {/* ACTIONS */}
          <div className="form-actions">
            <button type="submit" className="btn-primary">
              Create Marketing Officer
            </button>
          </div>
        </form>

        {/* sales man table */}
        <div style={{ marginTop: "10px" }}>
        <table className="w-full text-sm pt-10">
                <thead className="bg-zinc-50 text-zinc-500 pt-10">
                    <tr>
                        <th className="px-6 py-3 text-left font-medium">
                            FULL NAME
                        </th>
                         <th className="px-6 py-3 text-left font-medium">
                            EMAIL
                        </th>
                        <th className="px-6 py-3 text-left font-medium">PHONE NUMBER</th>
                        <th className="px-6 py-3 text-left font-medium">
                            DEPARTMENT
                        </th>
                        <th className="px-6 py-3 text-left font-medium">
                            CREATED DATE &amp; TIME
                        </th>
                        <th className="px-6 py-3 text-left font-medium">
                            UPDATED DATE &amp; TIME
                        </th>
                        <th className="px-6 py-3 text-left font-medium">
                           ACTIONS
                        </th>
                    </tr>
                </thead>

                <tbody className="divide-y">
                    {salesPersons.map((row, i) => (
                        <tr key={i} className="hover:bg-zinc-50">
                            <td className="px-6 py-4 font-medium text-zinc-900">
                                {row.full_name}
                            </td>

                            <td className="px-6 py-4 font-medium text-zinc-900">
                                {row.email}
                            </td>

                            <td className="px-6 py-4 text-zinc-600">
                                {row.phone_number}
                            </td>

                            
                         <td>{row.department || "-"}</td>

                            <td className="px-6 py-4 text-zinc-600">
                                {formatDateTime(row.created_at)}
                            </td>

                            <td className="px-6 py-4 text-zinc-600">
                                {formatDateTime(row.updated_at)}
                            </td>

                            <td className="actionCol">
                    <button type="button" className="iconBtn editBtn" aria-label="Edit" onClick={() => openEditModal(row)}>
                      ✎
                    </button>
                    <button
                      type="button"
                      className="iconBtn deleteBtn"
                      aria-label="Delete"
                      onClick={() => handleDeleteSalesPerson(row)}
                      disabled={deleteLoadingId === getSalesPersonId(row)}
                    >
                      🗑
                    </button>
                  </td>
                        </tr>
                    ))}

                    {/* {filteredCustomers.length === 0 && <tr>
                            <td
                                colSpan="6"
                                className="text-center py-6 text-zinc-500"
                            >
                                No customers found
                            </td>
                        </tr>} */}
                </tbody>
            </table>
            </div>

            {showEditModal ? (
              <div className="salesEditModalOverlay" onClick={() => !editLoading && setShowEditModal(false)}>
                <div className="salesEditModalCard" onClick={(e) => e.stopPropagation()}>
                  <h3>Edit Sales Person</h3>
                  <form onSubmit={handleUpdateSalesPerson}>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Full Name</label>
                        <input
                          name="full_name"
                          value={editForm.full_name}
                          onChange={handleEditInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Email</label>
                        <input
                          name="email"
                          type="email"
                          value={editForm.email}
                          onChange={handleEditInputChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>Phone Number</label>
                        <input
                          name="phone_number"
                          value={editForm.phone_number}
                          onChange={handleEditInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Department</label>
                        <select
                          name="department"
                          value={editForm.department}
                          onChange={handleEditInputChange}
                          required
                        >
                          <option>Marketing Officer</option>
                          <option>Industry Manager</option>
                        </select>
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>Account Status</label>
                        <select
                          name="account_status"
                          value={editForm.account_status}
                          onChange={handleEditInputChange}
                          required
                        >
                          <option value="active">active</option>
                          <option value="inactive">inactive</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label>Password</label>
                        <input
                          name="password"
                          type="text"
                          value={editForm.password}
                          onChange={handleEditInputChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="form-actions">
                      <button
                        type="button"
                        className="btn-secondary"
                        onClick={() => setShowEditModal(false)}
                        disabled={editLoading}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn-primary" disabled={editLoading}>
                        {editLoading ? "Updating..." : "Update"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            ) : null}
      </div>
    );
}
